/* Carriely – verkoophulpjes: verlanglijst (hartjes), recent bekeken, welkomstpop-up */
(() => {
  'use strict';
  const root = (window.Carriely && window.Carriely.routes && window.Carriely.routes.root) || '/';
  const base = root.replace(/\/$/, '');
  const store = {
    get(key) { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; } },
    set(key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) { /* geen opslag */ } }
  };
  const handleFrom = (href) => { const m = /\/products\/([^/?#]+)/.exec(href || ''); return m ? decodeURIComponent(m[1]) : null; };
  const HEART = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 20.3 4.6 13a4.7 4.7 0 0 1 6.7-6.7l.7.7.7-.7a4.7 4.7 0 0 1 6.7 6.7Z" fill="var(--heart-fill, none)" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';
  const cardCache = {};
  async function fetchCard(handle) {
    if (!cardCache[handle]) {
      cardCache[handle] = fetch(`${base}/products/${encodeURIComponent(handle)}?view=card`).then((r) => (r.ok ? r.text() : '')).catch(() => '');
    }
    return cardCache[handle];
  }

  /* Verlanglijst */
  const WL = 'cx-wishlist';
  const wl = () => store.get(WL);
  function paintHearts() {
    const list = wl();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((b) => {
      const on = list.includes(b.dataset.wishlistToggle);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', String(on));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => { el.textContent = list.length ? `(${list.length})` : ''; });
    document.querySelectorAll('[data-wishlist-badge]').forEach((el) => { el.textContent = list.length; el.dataset.count = list.length; });
  }
  function heartButton(handle, title, cls) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = `lx-heart ${cls || ''}`;
    b.dataset.wishlistToggle = handle;
    b.setAttribute('aria-label', `${title || 'Product'} bewaren in verlanglijst`);
    b.innerHTML = HEART;
    return b;
  }
  function decorate(scope) {
    (scope || document).querySelectorAll('[data-card]:not([data-wl-ready])').forEach((card) => {
      card.dataset.wlReady = '1';
      const link = card.querySelector('.card__title a');
      const handle = link && handleFrom(link.getAttribute('href'));
      const visual = card.querySelector('.card__visual') || card.querySelector('.card__media');
      if (!handle || !visual) return;
      visual.appendChild(heartButton(handle, link.textContent.trim(), 'lx-heart--card'));
    });
    const title = document.querySelector('[data-product] .info__title');
    if (title && !title.parentElement.querySelector('.lx-heart--pdp')) {
      const handle = handleFrom(location.pathname);
      if (handle) {
        const row = document.createElement('div');
        row.className = 'lx-title-row';
        title.parentNode.insertBefore(row, title);
        row.appendChild(title);
        row.appendChild(heartButton(handle, title.textContent.trim(), 'lx-heart--pdp'));
      }
    }
    paintHearts();
  }
  function headerIcon() {
    const right = document.querySelector('.site-header__right');
    if (!right || right.querySelector('[data-wishlist-open]')) return;
    const a = document.createElement('a');
    a.href = '#wishlist';
    a.className = 'icon-btn lx-wl-icon';
    a.dataset.drawerOpen = 'wishlist-drawer';
    a.dataset.wishlistOpen = '';
    a.setAttribute('aria-label', 'Verlanglijst');
    a.innerHTML = `${HEART}<span class="cart-count" data-wishlist-badge data-count="0" aria-hidden="true">0</span>`;
    const cart = right.querySelector('[data-cart-count]');
    right.insertBefore(a, cart ? cart.closest('a') : null);
  }
  async function renderDrawer() {
    const wrap = document.querySelector('[data-wishlist-items]');
    const empty = document.querySelector('[data-wishlist-empty]');
    if (!wrap) return;
    const list = wl();
    if (empty) empty.hidden = list.length > 0;
    const html = await Promise.all(list.map(fetchCard));
    wrap.innerHTML = html.join('');
    decorate(wrap);
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      const h = btn.dataset.wishlistToggle;
      const list = wl();
      const i = list.indexOf(h);
      if (i >= 0) list.splice(i, 1); else list.unshift(h);
      store.set(WL, list.slice(0, 40));
      paintHearts();
      if (i < 0) {
        btn.classList.add('is-pop');
        setTimeout(() => btn.classList.remove('is-pop'), 450);
        if (window.CarrielyUI) window.CarrielyUI.toast('Bewaard in je verlanglijst');
      }
      if (btn.closest('[data-wishlist-drawer]')) renderDrawer();
      return;
    }
    if (e.target.closest('[data-wishlist-open]')) renderDrawer();
  }, true);

  /* Recent bekeken */
  const RV = 'cx-recent';
  const current = handleFrom(location.pathname);
  if (current && document.querySelector('[data-product]')) {
    const list = store.get(RV).filter((h) => h !== current);
    list.unshift(current);
    store.set(RV, list.slice(0, 12));
  }
  document.querySelectorAll('[data-recent]').forEach(async (sec) => {
    const handles = store.get(RV).filter((h) => h !== sec.dataset.current).slice(0, 8);
    if (!handles.length) return;
    const html = (await Promise.all(handles.map(fetchCard))).filter(Boolean);
    if (!html.length) return;
    sec.querySelector('[data-recent-items]').innerHTML = html.join('');
    sec.hidden = false;
    decorate(sec);
  });

  /* Welkomstpop-up (wacht als er al een lade open is) */
  const popup = document.querySelector('[data-popup]');
  if (popup) {
    const KEY = 'cx-popup-closed';
    const posted = /customer_posted=true/.test(location.search) || /welcome-form/.test(location.hash);
    const open = (force) => {
      if (popup.classList.contains('is-open')) return;
      if (force !== true && document.body.classList.contains('is-locked')) { setTimeout(open, 15000); return; }
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      const panel = popup.querySelector('[role="dialog"]');
      setTimeout(() => { const f = popup.querySelector('input[type="email"]') || panel; if (f) f.focus({ preventScroll: true }); }, 120);
    };
    const close = () => {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-locked');
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) { /* geen opslag */ }
    };
    popup.addEventListener('click', (e) => { if (e.target.closest('[data-popup-close]')) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && popup.classList.contains('is-open')) close(); });
    popup.addEventListener('click', async (e) => {
      const c = e.target.closest('[data-copy]');
      if (!c) return;
      try { await navigator.clipboard.writeText(c.dataset.copy); const l = c.querySelector('[data-copy-label]'); if (l) l.textContent = 'Gekopieerd'; } catch (err) { /* geen klembord */ }
    });
    let last = 0;
    try { last = Number(localStorage.getItem(KEY) || 0); } catch (e) { last = 0; }
    const recentlyClosed = Date.now() - last < 14 * 24 * 3600 * 1000;
    if (posted) open(true);
    else if (!recentlyClosed && !popup.hasAttribute('data-editor')) {
      const delay = (Number(popup.dataset.delay) || 8) * 1000;
      const t = setTimeout(open, delay);
      const onLeave = (e) => {
        if (e.relatedTarget || e.clientY > 0) return;
        document.removeEventListener('mouseout', onLeave);
        clearTimeout(t);
        open();
      };
      document.addEventListener('mouseout', onLeave);
    }
  }

  /* Opstarten en nieuwe kaarten (filters, aanbevelingen) ook voorzien van een hartje */
  headerIcon();
  decorate(document);
  new MutationObserver((muts) => {
    if (muts.some((m) => Array.from(m.addedNodes).some((n) => n.nodeType === 1 && (n.matches('[data-card]') || (n.querySelector && n.querySelector('[data-card]')))))) decorate(document);
  }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
})();
